import { useLayoutEffect, useMemo, useRef, useState } from 'react'

import { Splitter } from 'antd'
import { createStyles } from 'antd-style'

import { unitTools } from '@eastcoal/common/utils/css'
import { pick } from '@eastcoal/common/utils/object'

import { ContractDesignerEditor } from '../../../editor/Editor'
import { useContractDesignerEditorStore } from '../../../editor/Store/hooks/useStore'
import { Toolbar } from '../../../editor/Toolbar'
import { LeftPanel } from '../../LeftPanel'
import { RightPanel } from '../../RightPanel'
import { Topbar } from '../../Topbar'

const useStyles = createStyles(({ token }) => ({
  container: {
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    gap: token.marginSM,
    backgroundColor: token.colorBgLayout
  },
  header: {
    flex: 'none',
    background: token.colorWhite,
    boxShadow: token.boxShadowTertiary
  },
  content: {
    flex: 1,
    paddingInline: token.paddingXXS,
    overflow: 'hidden'
  },
  editor: {
    height: '100%',
    marginInline: 'auto'
  }
}))

export const ContractDesignerLayout = () => {
  const { paperSpec } = useContractDesignerEditorStore(state =>
    pick(state, ['paperSpec'])
  )

  const mainRef = useRef<HTMLDivElement>(null)

  const editorWidth = useMemo(() => {
    const paperWidth = Number.parseFloat(paperSpec.width)
    return Number.parseFloat(unitTools.cm2px(paperWidth))
  }, [paperSpec.width])

  const [widths, setWidths] = useState<number[]>([0, 0, 0])

  useLayoutEffect(() => {
    const mainWidth = mainRef.current
      ? Number.parseFloat(window.getComputedStyle(mainRef.current, null).width)
      : 0
    // -20: 相当于左右两边设置 10px margin
    const siderWidth = mainWidth ? (mainWidth - editorWidth - 20) / 3 : 0
    setWidths([siderWidth, editorWidth, siderWidth * 2])
  }, [editorWidth])

  const { styles } = useStyles()

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <Topbar />
        <Toolbar />
      </header>
      <main ref={mainRef} className={styles.content}>
        <Splitter onResize={setWidths}>
          <Splitter.Panel collapsible size={widths[0]}>
            <LeftPanel />
          </Splitter.Panel>
          <Splitter.Panel min={editorWidth} size={widths[1]}>
            <ContractDesignerEditor
              className={styles.editor}
              style={{ width: editorWidth }}
            />
          </Splitter.Panel>
          <Splitter.Panel size={widths[2]}>
            <RightPanel />
          </Splitter.Panel>
        </Splitter>
      </main>
    </div>
  )
}
